import { render, staticRenderFns } from "./MessageListDialog.vue?vue&type=template&id=511a89a8&scoped=true&"
import script from "./MessageListDialog.vue?vue&type=script&lang=js&"
export * from "./MessageListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a89a8",
  null
  
)

export default component.exports